import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { TileSlider } from 'Components'
import BuildingPreviewWithFav from 'Components/BuildingPreviewWithFav'

import { _SimilarBuildingContainer, _BuildingPreviewCol } from './styles'

const GA_CATEGORY = 'Building'
const GA_SOURCE = 'Similar Buildings'

class SimilarBuildings extends Component {
  constructor(props) {
    super(props)
    this.renderSimilarBuildings = this.renderSimilarBuildings.bind(this)
    this.handleBuildingPreviewClick = this.handleBuildingPreviewClick.bind(this)
  }
  handleBuildingPreviewClick() {
    const category = this.props.source || GA_CATEGORY
    this.props.googleAnalyticsEvent({
      category,
      label: 'backend',
      action: [
        'click',
      ],
    })
  }
  renderSimilarBuildings() {
    const { similarBuildings, mobileBrowser, userIsAuthentificated } = this.props

    const similarListings = similarBuildings.map((similarBuilding) => (
      <_BuildingPreviewCol
        key={similarBuilding.name + ' ' + similarBuilding.id}
        xs={12}
        // sm={6}
        // md={3}
      >
        <BuildingPreviewWithFav
          showDistance
          building={similarBuilding}
          handleClick={this.handleBuildingPreviewClick}
          userIsAuthentificated={userIsAuthentificated}
          gaCategory={GA_CATEGORY}
          gaSource={GA_SOURCE}
        />
      </_BuildingPreviewCol>
    ))
    if(mobileBrowser) {
      return similarListings
    }
    return (
      <TileSlider nearbyListingsOrSimilarListings>
        {similarListings}
      </TileSlider>

    )
  }


  render() {
    const { similarBuildings, mobileBrowser } = this.props
    return (
      <_SimilarBuildingContainer isMobile={!!mobileBrowser}>
        {
          similarBuildings && this.renderSimilarBuildings()
        }

      </_SimilarBuildingContainer>
    )
  }
}

SimilarBuildings.propTypes = {
  similarBuildings: PropTypes.arrayOf(PropTypes.shape({})),
  mobileBrowser: PropTypes.bool,
  userIsAuthentificated: PropTypes.bool,
  googleAnalyticsEvent: PropTypes.func,
  source: PropTypes.string,
}

export default SimilarBuildings
